import { useState, Fragment } from "react";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";

import { Menu, Transition } from "@headlessui/react";
import { EllipsisHorizontalIcon, EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";

import Pagination from "../Pagination";
import ConfirmationModalNew from "../../common/ConfirmationModalNew";
import SortIcon from "../../common/SortIcon";
import {
  formatDateToDD_MMM_YYYY,
  formatPhoneNumber,
  calculateAge,
} from "../../../helpers/functions";
import { setPatientsQueryParams } from "../../../redux/modules/patient/actions";
import ListLoading from "./loading";
import { capitalizeFirstLetter } from "../../../helpers/functions";
import NewToolTip from "../../common/New-ToolTip";

const List = ({
  paginationRange,
  activePage,
  totalPages,
  patientList,
  loading,
  isFilterApplied,
  search,
  advanceSearchCheckBox,
}) => {
  const dispatch = useDispatch();
  const { order, sort } = useSelector((state) => state.patients);
  const navigate = useNavigate();

  const [isDuplicatePatientDetected, setIsDuplicatePatientDetected] =
    useState(false);
  const [selectedPatient, setselectedPatient] = useState(null);
  const [visibleHealthCards, setVisibleHealthCards] = useState(new Set());

  const toggleHealthCardVisibility = (patientId) => {
    setVisibleHealthCards((prev) => {
      const next = new Set(prev);
      next.has(patientId) ? next.delete(patientId) : next.add(patientId);
      return next;
    });
  };

  const handleSortOrder = (newSort, newOrder) => {
    dispatch(
      setPatientsQueryParams({ sort: newSort, order: newOrder, page: 1 })
    );
  };

  const handlePatientClick = (id) => {
    checkForSamePatient(id);
  };

  const renderInactive = () => {
    return (
      <div className="flex items-center border-red-300 border bg-red-300 overflow-hidden rounded-[16px] w-max">
        <div className="text-red-300 font-semibold py-1 text-[10px] px-2 leading-[12px] bg-red-50">
          Inactive
        </div>
      </div>
    );
  };

  const checkForSamePatient = (id) => {
    setselectedPatient(patientList.find((o) => o.id === id));
    if (!advanceSearchCheckBox && search.length > 0) {
      const isMultiplePatientDetected = patientList.filter(
        (o) => o.firstName === search || o.lastName === search
      );
      if (isMultiplePatientDetected.length > 1) {
        setIsDuplicatePatientDetected(true);
      } else {
        navigate(`/patient/${id}/`);
      }
    } else {
      navigate(`/patient/${id}/`);
    }
  };

  return (
    <div className="">
      {loading ? (
        <ListLoading />
      ) : (
        <>
      {/* Patient list table */}
        <div className="flow-root bg-white">
          <div className="overflow-x-auto ">
            <div className="inline-block min-w-full align-middle ">
              <div className="overflow-hidden border border-gray-50 rounded-[4px]">
                <table className="min-w-full divide-y divide-gray-100 table-fixed">
                  <thead className="bg-gray-20">
                    <tr>
                      <th
                        scope="col"
                        className="py-4 pl-4 w-[25%] pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                      >
                        <a href="#" className="inline-flex items-center group">
                          Patient Name
                          <span
                            onClick={() =>
                              handleSortOrder(
                                "lastName",
                                order === "desc" ? "asc" : "desc"
                              )
                            }
                            className="flex items-center justify-center ml-2 text-gray-400 rounded cursor-pointer"
                          >
                            <SortIcon
                              isDownActive={sort === "lastName" && order === "desc"}
                              isUpActive={sort === "lastName" && order === "asc"}
                              className="text-gray-600"
                            />
                          </span>
                        </a>
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-4 w-[10%] text-left text-sm font-semibold text-gray-900"
                      >
                        <a href="#" className="inline-flex items-center group">
                          Status
                          <span
                            onClick={() =>
                              handleSortOrder(
                                "status",
                                order === "desc" ? "asc" : "desc"
                              )
                            }
                            className="flex items-center justify-center ml-2 text-gray-400 rounded cursor-pointer"
                          >
                            <SortIcon
                              isDownActive={sort === "status" && order === "desc"}
                              isUpActive={sort === "status" && order === "asc"}
                              className="text-gray-600"
                            />
                          </span>
                        </a>
                      </th>
                      <th
                        scope="col"
                        className="px-3 w-[12%] py-4 text-left text-sm font-semibold text-gray-900"
                      >
                        <a href="#" className="inline-flex items-center group">
                          Date of Birth
                          <span
                            onClick={() =>
                              handleSortOrder(
                                "dateOfBirth",
                                order === "desc" ? "asc" : "desc"
                              )
                            }
                            className="flex items-center justify-center ml-2 text-gray-400 rounded cursor-pointer"
                          >
                            <SortIcon
                              isDownActive={sort === "dateOfBirth" && order === "desc"}
                              isUpActive={sort === "dateOfBirth" && order === "asc"}
                              className="text-gray-600"
                            />
                          </span>
                        </a>
                      </th>
                      <th
                        scope="col"
                        className="px-3 w-[10%] py-4 text-left text-sm font-semibold text-gray-900"
                      >
                        Age
                      </th>
                      <th
                        scope="col"
                        className="px-3 w-[12%] py-4 text-left text-sm font-semibold text-gray-900"
                      >
                        Mobile Number
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-4 w-[13%] text-left text-sm font-semibold text-gray-900"
                      >
                        Health Card
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-4 w-[12%] text-left text-sm font-semibold text-gray-900"
                      >
                        <a href="#" className="inline-flex items-center group">
                          Last Access
                          <span
                            onClick={() =>
                              handleSortOrder(
                                "updatedAt",
                                order === "desc" ? "asc" : "desc"
                              )
                            }
                            className="flex items-center justify-center ml-2 text-gray-400 rounded cursor-pointer"
                          >
                            <SortIcon
                              isDownActive={sort === "updatedAt" && order === "desc"}
                              isUpActive={sort === "updatedAt" && order === "asc"}
                              className="text-gray-600"
                            />
                          </span>
                        </a>
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-4 w-[9%] text-center text-sm font-semibold text-gray-900"
                      >Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50 ">
                    {!patientList || patientList.length === 0 ? (
                        <tr
                          className=""
                        >
                          <td colSpan="8" className="py-4 font-medium text-center text-gray-900">
                            {advanceSearchCheckBox ? "No Patients Found with Advanced Search" : "No Patient Found"}
                          </td>
                        </tr>
                    ) : (
                      patientList?.map((person, index) => {
                        let name = person.lastName + " " + person.firstName;
                        const healthCardNumber =
                          person?.provincialInsurance?.cardNumber?.trim() ?? "";
                        const versionCode =
                          person?.provincialInsurance?.versionCode?.trim() ?? "";
                        const hasProvincialInsurance =
                          healthCardNumber.length > 0 ||
                          versionCode.length > 0;
                        const healthCard = hasProvincialInsurance
                          ? [healthCardNumber, versionCode]
                              .filter((value) => value?.length)
                              .join(" - ")
                          : "No Provincial Insurance";
                        const healthCardTooltipId = `health_card_${
                          healthCardNumber || versionCode || "provincial"
                        }_tooltip`;
                        const healthCardExpiry =
                          person?.provincialInsurance?.expiryDate;
                        const isHealthCardExpired =
                          hasProvincialInsurance && healthCardExpiry
                            ? new Date() > new Date(healthCardExpiry)
                            : false;
                        let phone = person?.contactInfo?.primaryPhone;
                        return (
                          <tr
                            className="transition-colors duration-300 cursor-pointer group hover:bg-blue-100 "
                            key={index}
                          >
                            <td
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePatientClick(person.id);
                              }}
                              className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-6"
                            >
                              <div className="flex items-center space-x-3 ">
                                <Avatar
                                  className="font-medium text-body-sm"
                                  size="32"
                                  round
                                  textSizeRatio={2.5}
                                  color={`rgba(46, 77, 91, 1)`}
                                  name={name}
                                />
                                <p className="font-semibold text-teal-600 text-body-sm">
                                  {person.lastName + " " + person.firstName}
                                </p>
                              </div>
                            </td>
                            <td
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePatientClick(person.id);
                              }}
                              className={`${
                                person.status === "active"
                                  ? "text-gray-700"
                                  : "text-red-300 font-semibold"
                              } px-3 py-4 text-sm whitespace-nowrap`}
                            >
                              {person.status === "active"
                                ? "Active"
                                : "Inactive"}
                            </td>
                            <td
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePatientClick(person.id);
                              }}
                              className="px-3 py-4 text-sm text-gray-700 whitespace-nowrap"
                            >
                              {formatDateToDD_MMM_YYYY(person.dateOfBirth)}
                            </td>
                            <td
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePatientClick(person.id);
                              }}
                              className="px-3 py-4 text-sm text-gray-700 whitespace-nowrap"
                            >
                              {calculateAge(person.dateOfBirth)}
                            </td>
                            <td
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePatientClick(person.id);
                              }}
                              className="px-3 py-4 text-sm text-gray-700 whitespace-nowrap"
                            >
                              {formatPhoneNumber(phone)}
                            </td>
                            <td
                              className={`px-3 py-4 text-sm ${
                                isHealthCardExpired
                                  ? "text-red-700"
                                  : "text-gray-700"
                              } whitespace-nowrap`}
                              data-tooltip-id={
                                isHealthCardExpired ? healthCardTooltipId : undefined
                              }
                            >
                              <div className="flex items-center gap-2">
                                {hasProvincialInsurance && (
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleHealthCardVisibility(person.id);
                                    }}
                                    className="text-gray-400 hover:text-gray-600 focus:outline-none flex-shrink-0"
                                  >
                                    {visibleHealthCards.has(person.id)
                                      ? <EyeSlashIcon className="w-4 h-4" />
                                      : <EyeIcon className="w-4 h-4" />}
                                  </button>
                                )}
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handlePatientClick(person.id);
                                  }}
                                  className="cursor-pointer"
                                >
                                  {hasProvincialInsurance
                                    ? (visibleHealthCards.has(person.id) ? healthCard : '••••••••')
                                    : healthCard}
                                </span>
                              </div>
                              {isHealthCardExpired && (
                                <NewToolTip
                                  id={healthCardTooltipId}
                                  place="bottom"
                                  offset={-16}
                                  anchorSelect={`[data-tooltip-id="${healthCardTooltipId}"]`}
                                  render={() => (
                                    <div className="!bg-white max-w-[460px] relative text-teal-300 text-body-sm p-2">
                                      Expired or No Expiry Date
                                    </div>
                                  )}
                                />
                              )}
                            </td>
                            <td
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePatientClick(person.id);
                              }}
                              className="px-3 py-4 text-sm text-gray-700 whitespace-nowrap"
                            >
                              {formatDateToDD_MMM_YYYY(new Date())}
                            </td>

                            <td className="relative py-4 pl-4 pr-4 text-sm font-medium text-right whitespace-nowrap sm:pr-4">
                              <div className="flex justify-center pr-0">
                                <Menu as="div" className="relative inline-block text-left">
                                  <div>
                                    <Menu.Button
                                      className="p-2 rounded hover:bg-gray-20 focus:outline-none"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <EllipsisHorizontalIcon className="w-5 h-5 text-teal-600  scale-x-[1.4] scale-y-[1.4]" />
                                    </Menu.Button>
                                  </div>
                                  <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform translate-y-2 opacity-0 scale-95"
                                    enterTo="transform translate-y-0 opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform translate-y-0 opacity-100 scale-100"
                                    leaveTo="transform translate-y-2 opacity-0 scale-95"
                                    >
                                     <Menu.Items className="absolute top-full left-0 min-w-[60px] w-auto origin-top-right bg-white rounded-md shadow-md ring-1 ring-black ring-opacity-5">
                                      <Menu.Item>
                                        {({ active }) => (
                                          <button
                                            className={`block text-left w-[70px] h-[38px] px-[10px] py-[10px] flex items-center gap-[10px] hover:bg-gray-50 rounded-md ${active ? "bg-gray-50" : ""}`}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handlePatientClick(person.id);
                                            }}
                                          >
                                            Edit
                                          </button>
                                        )}
                                      </Menu.Item>
                                    </Menu.Items>
                                  </Transition>
                                </Menu>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
                <Pagination
                  totalPages={totalPages}
                  paginationRange={paginationRange}
                  activePage={activePage}
                />
              </div>
            </div>
          </div>
        </div>
        </>
      )}

      {/* Same name pop-up */}
      <ConfirmationModalNew
        open={isDuplicatePatientDetected}
        title={"Same Name Alert"}
        type={"primary"}
        confirmText="Okay"
        content={() => (
          <>
            This patient &nbsp;
            <b>
              {capitalizeFirstLetter(selectedPatient?.lastName)},&nbsp;
              {capitalizeFirstLetter(selectedPatient?.firstName)}
            </b>
            &nbsp; shares the same{" "}
            {selectedPatient?.firstName === search ? "FIRST" : "LAST"} name as
            another patient in your pharmacy.
            <br />
            <br />
            Ensure you access the correct chart.
          </>
        )}
        handleClose={() => setIsDuplicatePatientDetected(false)}
        onCross={() => setIsDuplicatePatientDetected(false)}
        confirmAction={() => navigate(`/patient/${selectedPatient?.id}/`)}
      />
    </div>
  );
};

export default List;
